import React, { useState } from 'react';

const Tabs = ({ children, errors, tabFieldMapping }) => {
  const [activeTab, setActiveTab] = useState(children[0].props.label);

  const handleClick = (label) => {
    setActiveTab(label);
  };

  const tabHasErrors = (index) => {
    if (!errors || !tabFieldMapping[index]) return false;
    return tabFieldMapping[index].some(field => errors.hasOwnProperty(field));
  };

  return (
    <div>
      <ul className="tabs">
        {children.map((tab) => {
          const label = tab.props.label;
          const hasError = tabHasErrors(label);
          return (
            <li
              key={label}
              className={`${label === activeTab ? 'active' : ''} ${hasError ? 'tab-error' : ''}`}
              onClick={() => handleClick(label)}
              style={hasError ? { color: 'red' } : {}}
            >
              {label}
            </li>
          );
        })}
      </ul>

      <div className="tab-content">
        {children.map((content) => {
          if (content.props.label === activeTab) return <div key={content.props.label}>{content.props.children}</div>;
          else return null;
        })}
      </div>
    </div>
  );
};

const Tab = ({ children }) => {
  return <>{children}</>;
};

export { Tabs, Tab };
